var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1034.04 313.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6d66fe;\n      }\n\n      .cls-2 {\n        fill: #6766fe;\n      }\n\n      .cls-3 {\n        fill: #0bb1ff;\n      }\n\n      .cls-4 {\n        fill: #06c8ff;\n      }\n\n      .cls-5 {\n        fill: #6a66fe;\n      }\n\n      .cls-6 {\n        fill: #04d6ff;\n      }\n\n      .cls-7 {\n        fill: #4865fe;\n      }\n\n      .cls-8 {\n        fill: #1584fe;\n      }\n\n      .cls-9 {\n        fill: #1b69fe;\n      }\n\n      .cls-10 {\n        fill: #07c6ff;\n      }\n\n      .cls-11 {\n        fill: #0dabff;\n      }\n\n      .cls-12 {\n        fill: #0cafff;\n      }\n\n      .cls-13 {\n        fill: #109bfe;\n      }\n\n      .cls-14 {\n        fill: #0da7ff;\n      }\n\n      .cls-15 {\n        fill: #2964fe;\n      }\n\n      .cls-16 {\n        fill: #03d8ff;\n      }\n\n      .cls-17 {\n        fill: #1972fe;\n      }\n\n      .cls-18 {\n        fill: #1878fe;\n      }\n\n      .cls-19 {\n        fill: #2063fe;\n      }\n\n      .cls-20 {\n        fill: #7b67fe;\n      }\n\n      .cls-21 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-22 {\n        fill: #05ceff;\n      }\n\n      .cls-23 {\n        fill: #06ccff;\n      }\n\n      .cls-24 {\n        fill: #04d5ff;\n      }\n\n      .cls-25 {\n        fill: #02ddff;\n      }\n\n      .cls-26 {\n        fill: #177cfe;\n      }\n\n      .cls-27 {\n        fill: #8f68fe;\n      }\n\n      .cls-28 {\n        fill: #1d63fe;\n      }\n\n      .cls-29 {\n        fill: #06c9ff;\n      }\n\n      .cls-30 {\n        fill: #09bcff;\n      }\n\n      .cls-31 {\n        fill: #09bbff;\n      }\n\n      .cls-32 {\n        fill: #05cfff;\n      }\n\n      .cls-33 {\n        fill: #03d9ff;\n      }\n\n      .cls-34 {\n        fill: #1a6cfe;\n      }\n\n      .cls-35 {\n        fill: #8768fe;\n      }\n\n      .cls-36 {\n        fill: #5765fe;\n      }\n\n      .cls-37 {\n        fill: #2663fe;\n      }\n\n      .cls-38 {\n        fill: #8567fe;\n      }\n\n      .cls-39 {\n        fill: #0ea6ff;\n      }\n\n      .cls-40 {\n        fill: #1971fe;\n      }\n\n      .cls-41 {\n        fill: #05d0ff;\n      }\n\n      .cls-42 {\n        fill: #167efe;\n      }\n\n      .cls-43 {\n        fill: #1291fe;\n      }\n\n      .cls-44 {\n        fill: #0bb4ff;\n      }\n\n      .cls-45 {\n        fill: #06caff;\n      }\n\n      .cls-46 {\n        fill: #0fa2fe;\n      }\n\n      .cls-47 {\n        fill: #09beff;\n      }\n\n      .cls-48 {\n        fill: #0ab5ff;\n      }\n\n      .cls-49 {\n        fill: #0ab8ff;\n      }\n\n      .cls-50 {\n        fill: #0da9ff;\n      }\n\n      .cls-51 {\n        fill: #0fa0fe;\n      }\n\n      .cls-52 {\n        fill: #6466fe;\n      }\n\n      .cls-53 {\n        fill: #1586fe;\n      }\n\n      .cls-54 {\n        fill: #0bb2ff;\n      }\n\n      .cls-55 {\n        fill: #1a6afe;\n      }\n\n      .cls-56 {\n        fill: #08c1ff;\n      }\n\n      .cls-57 {\n        fill: #0f9efe;\n      }\n\n      .cls-58 {\n        fill: #4c65fe;\n      }\n\n      .cls-59 {\n        fill: #1b68fe;\n      }\n\n      .cls-60 {\n        fill: #9168fe;\n      }\n\n      .cls-61 {\n        fill: #0caeff;\n      }\n\n      .cls-62 {\n        fill: #1582fe;\n      }\n\n      .cls-63 {\n        fill: #148afe;\n      }\n\n      .cls-64 {\n        fill: #07c4ff;\n      }\n\n      .cls-65 {\n        fill: #4465fe;\n      }\n\n      .cls-66 {\n        fill: #05cdff;\n      }\n\n      .cls-67 {\n        fill: #5a66fe;\n      }\n\n      .cls-68 {\n        fill: #9068fe;\n      }\n\n      .cls-69 {\n        fill: #03daff;\n      }\n\n      .cls-70 {\n        fill: #1680fe;\n      }\n\n      .cls-71 {\n        fill: #5e66fe;\n      }\n\n      .cls-72 {\n        fill: #1195fe;\n      }\n\n      .cls-73 {\n        fill: #04d3ff;\n      }\n\n      .cls-74 {\n        fill: #7e67fe;\n      }\n\n      .cls-75 {\n        fill: #0ab7ff;\n      }\n\n      .cls-76 {\n        fill: #5065fe;\n      }\n\n      .cls-77 {\n        fill: #196ffe;\n      }\n\n      .cls-78 {\n        fill: #03d6ff;\n      }\n\n      .cls-79 {\n        fill: #02dcff;\n      }\n\n      .cls-80 {\n        fill: #02dbff;\n      }\n\n      .cls-81 {\n        fill: #1293fe;\n      }\n\n      .cls-82 {\n        fill: #8c68fe;\n      }\n\n      .cls-83 {\n        fill: #109dfe;\n      }\n\n      .cls-84 {\n        fill: #9268fe;\n      }\n\n      .cls-85 {\n        fill: #08bfff;\n      }\n\n      .cls-86 {\n        fill: #3864fe;\n      }\n\n      .cls-87 {\n        fill: #1e63fe;\n      }\n\n      .cls-88 {\n        fill: #0cacff;\n      }\n\n      .cls-89 {\n        fill: #4065fe;\n      }\n\n      .cls-90 {\n        fill: #07c7ff;\n      }\n\n      .cls-91 {\n        fill: #1197fe;\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-93 {\n        fill: #05d1ff;\n      }\n\n      .cls-94 {\n        fill: #09baff;\n      }\n\n      .cls-95 {\n        clip-rule: evenodd;\n        fill: none;\n      }\n\n      .cls-96 {\n        fill: #7267fe;\n      }\n\n      .cls-97 {\n        fill: #177afe;\n      }\n\n      .cls-98 {\n        fill: #03d7ff;\n      }\n\n      .cls-99 {\n        fill: #1b66fe;\n      }\n\n      .cls-100 {\n        fill: #02deff;\n      }\n\n      .cls-101 {\n        fill: #2d64fe;\n      }\n\n      .cls-102 {\n        fill: #8d68fe;\n      }\n\n      .cls-103 {\n        fill: #0ea4fe;\n      }\n\n      .cls-104 {\n        fill: #1c64fe;\n      }\n\n      .cls-105 {\n        fill: #6f66fe;\n      }\n\n      .cls-106 {\n        fill: #1876fe;\n      }\n\n      .cls-107 {\n        fill: #7c67fe;\n      }\n\n      .cls-108 {\n        fill: #7467fe;\n      }\n\n      .cls-109 {\n        fill: #8e68fe;\n      }\n\n      .cls-110 {\n        fill: #08c3ff;\n      }\n\n      .cls-111 {\n        fill: #5365fe;\n      }\n\n      .cls-112 {\n        fill: #1099fe;\n      }\n\n      .cls-113 {\n        fill: #1a6dfe;\n      }\n\n      .cls-114 {\n        fill: #04d2ff;\n      }\n\n      .cls-115 {\n        fill: #8667fe;\n      }\n\n      .cls-116 {\n        fill: #06cbff;\n      }\n\n      .cls-117 {\n        fill: #8067fe;\n      }\n\n      .cls-118 {\n        fill: #3c64fe;\n      }\n\n      .cls-119 {\n        fill: #3164fe;\n      }\n\n      .cls-120 {\n        fill: #1b67fe;\n      }\n\n      .cls-121 {\n        fill: #7667fe;\n      }\n\n      .cls-122 {\n        fill: #7867fe;\n      }\n\n      .cls-123 {\n        fill: #138ffe;\n      }\n\n      .cls-124 {\n        fill: #1874fe;\n      }\n\n      .cls-125 {\n        fill: #08c0ff;\n      }\n\n      .cls-126 {\n        fill: #2363fe;\n      }\n\n      .cls-127 {\n        fill: #1488fe;\n      }\n\n      .cls-128 {\n        fill: #8267fe;\n      }\n\n      .cls-129 {\n        fill: #138bfe;\n      }\n\n      .cls-130 {\n        fill: #8b68fe;\n      }\n\n      .cls-131 {\n        fill: #138dfe;\n      }\n\n      .cls-132 {\n        fill: #04d4ff;\n      }\n\n      .cls-133 {\n        fill: #8a68fe;\n      }\n\n      .cls-134 {\n        fill: #9368fe;\n      }\n\n      .cls-135 {\n        fill: #3564fe;\n      }\n\n      .cls-136 {\n        fill: #6166fe;\n      }\n\n      .cls-137 {\n        fill: #07c5ff;\n      }\n\n      .cls-138 {\n        fill: #1c63fe;\n      }\n\n      .cls-139 {\n        fill: #8367fe;\n      }\n\n      .cls-140 {\n        fill: #8968fe;\n      }\n\n      .cls-141 {\n        fill: #1c65fe;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m77.71,198.32h-.01c-13.32,13.29-26.66,26.57-39.98,39.85-1.67,1.36-3.75,2.11-5.9,2.11-5.15,0-9.32-4.17-9.32-9.32v-44.56c.07-1.13.54-2.15,1.27-2.92,13.32-13.28,26.67-26.57,39.99-39.85,1.67-1.36,3.75-2.11,5.9-2.11,5.15,0,9.32,4.17,9.32,9.32v44.47c-.05,1.16-.53,2.22-1.28,3.01h0Zm144.83,0h-.01c-13.32,13.29-26.66,26.57-39.97,39.85-1.67,1.36-3.75,2.11-5.9,2.11-5.15,0-9.32-4.17-9.32-9.32V97.19c.07-1.13.54-2.15,1.27-2.92,13.32-13.28,26.67-26.57,39.99-39.85,1.67-1.36,3.75-2.11,5.9-2.11,5.15,0,9.32,4.17,9.32,9.32v133.67c-.05,1.16-.53,2.22-1.28,3.01h0Zm-72.42,0h-.01c-13.32,13.29-26.66,26.57-39.97,39.85-1.67,1.36-3.75,2.11-5.9,2.11-5.15,0-9.32-4.17-9.32-9.32v-84.12c.07-1.13.54-2.15,1.27-2.92,13.32-13.28,26.67-26.57,39.99-39.85,1.67-1.36,3.75-2.11,5.9-2.11,5.15,0,9.32,4.17,9.32,9.32v84.03c-.05,1.16-.53,2.22-1.28,3.01Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m927.57,174.93h72.97c-.7-2.67-1.64-5.27-2.83-7.76-2.93-6.12-7.1-11.15-12.83-14.83-6-3.85-12.88-5.28-19.94-5.28-7.43,0-14.53,1.59-20.87,5.57-6.1,3.83-10.61,9.05-13.8,15.49-1.09,2.19-1.98,4.47-2.7,6.81h0Zm-.71,30.12c.91,3.42,2.22,6.7,3.97,9.8,3.7,6.57,8.77,11.78,15.28,15.6,6.9,4.05,14.58,5.68,22.53,5.68,5.32,0,10.54-.98,15.57-2.7,4.23-1.45,8.66-3.47,12.08-6.43l.13-.11c3.02-2.47,6.57-3.83,10.46-3.97,3.88-.14,7.61.98,10.65,3.42l.2.16.19.17c3.29,3.03,5.47,6.89,5.63,11.42.16,4.61-1.88,8.7-5.37,11.65-6.72,5.67-14.67,9.75-22.91,12.74-8.54,3.1-17.51,4.99-26.62,4.99-13.71,0-26.97-2.89-38.95-9.69-11.43-6.49-20.43-15.57-26.88-27.02-6.78-12.03-9.68-25.31-9.68-39.05s2.64-26.96,9.12-39.04c6.03-11.25,14.5-20.38,25.41-27.04,11.36-6.93,24.05-9.93,37.29-9.93s25.35,2.8,36.43,9.56c10.58,6.46,18.64,15.4,24.24,26.43,5.94,11.7,8.43,24.48,8.43,37.54,0,4.39-1.49,8.43-4.7,11.48-3.12,2.96-7.09,4.31-11.35,4.31h-91.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m803.74,235.87c7.77,0,15.15-1.71,21.83-5.75,6.47-3.91,11.52-9.19,15.23-15.77,3.98-7.06,5.62-14.83,5.62-22.88s-1.7-15.74-5.63-22.79c-3.67-6.58-8.68-11.86-15.17-15.71-6.71-3.98-14.12-5.66-21.88-5.66s-15.08,1.74-21.79,5.68c-6.56,3.85-11.66,9.14-15.41,15.74-3.99,7.02-5.73,14.69-5.73,22.74s1.67,15.81,5.71,22.84c3.79,6.61,8.94,11.89,15.48,15.8,6.68,3.99,13.98,5.77,21.74,5.77h0Zm42.19-105.2V49.36c.1-2.45,1.05-4.67,2.56-6.4,5.26-5.25,10.53-10.49,15.79-15.74,1.67-1.36,3.75-2.1,5.9-2.1,5.15,0,9.32,4.17,9.32,9.32v17.59s0,0,0,0v140.54s0,.07,0,.07c-.29,13.52-3.64,26.4-10.48,38.11-6.61,11.32-15.68,20.35-27.04,26.9-11.77,6.78-24.71,9.84-38.24,9.84s-26.75-3.09-38.63-9.97c-11.42-6.62-20.54-15.74-27.16-27.16-6.92-11.94-9.97-25.13-9.97-38.88s2.98-26.66,9.68-38.55c6.39-11.34,15.2-20.49,26.37-27.18,11.55-6.91,24.32-10.02,37.73-10.02,11.63,0,22.88,2.41,33.2,7.86,3.86,2.04,7.54,4.4,10.96,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m638.76,235.87c7.82,0,15.26-1.7,22.04-5.68,6.47-3.8,11.49-8.98,15.12-15.55,3.92-7.09,5.52-14.88,5.52-22.94s-1.62-15.94-5.54-23.09c-3.61-6.6-8.61-11.83-15.11-15.64-6.78-3.98-14.21-5.68-22.04-5.68s-15.26,1.7-22.04,5.68c-6.53,3.83-11.57,9.09-15.26,15.7-3.97,7.12-5.63,14.93-5.63,23.04s1.64,15.83,5.62,22.89c3.7,6.57,8.77,11.78,15.28,15.6,6.78,3.98,14.21,5.68,22.04,5.68h0Zm0,31.6c-13.71,0-26.89-3-38.84-9.83-11.45-6.54-20.55-15.64-27.09-27.09-6.83-11.95-9.83-25.13-9.83-38.84s2.96-27.06,9.83-39.09c6.54-11.45,15.64-20.55,27.09-27.09,11.95-6.83,25.13-9.83,38.84-9.83s26.83,2.98,38.74,9.84c11.39,6.56,20.43,15.67,26.95,27.08,6.86,12.01,9.99,25.26,10.07,39.04.08,13.78-3.04,26.96-9.97,38.92-6.59,11.38-15.65,20.48-27.05,27.04-11.9,6.86-25.06,9.84-38.74,9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m329.06,235.87c7.83,0,15.24-1.74,21.99-5.77,6.51-3.89,11.6-9.15,15.33-15.75,3.98-7.06,5.62-14.83,5.62-22.88s-1.7-15.74-5.63-22.79c-3.69-6.61-8.73-11.86-15.26-15.7-6.78-3.98-14.21-5.68-22.04-5.68s-15.08,1.74-21.79,5.68c-6.5,3.82-11.49,9.04-15.11,15.65-3.88,7.08-5.54,14.8-5.54,22.84s1.6,15.85,5.52,22.94c3.65,6.6,8.7,11.83,15.17,15.7,6.68,4,13.98,5.77,21.74,5.77h0Zm-42.19-105.17c3.47-2.72,7.19-5.1,11.11-7.15,10.36-5.42,21.64-7.85,33.3-7.85,13.41,0,26.18,3.11,37.73,10.02,11.18,6.69,19.98,15.84,26.37,27.18,6.7,11.89,9.68,24.96,9.68,38.55s-3.05,26.93-9.97,38.88c-6.62,11.42-15.74,20.54-27.16,27.16-11.94,6.92-25.13,9.97-38.88,9.97s-26.48-3.06-38.24-9.84c-11.36-6.54-20.43-15.58-27.04-26.9-6.85-11.73-10.06-24.65-10.23-38.2V49.05c.13-2.55,1.18-4.86,2.82-6.61,5.09-5.07,10.19-10.15,15.27-15.22,1.67-1.36,3.75-2.1,5.9-2.1,5.03,0,9.13,3.99,9.32,8.98,0,.12,0,.24,0,.36v8.27h0s0,87.98,0,87.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m545.84,141.89c3.12,3.5,4.56,7.87,3.53,12.51-.94,4.22-3.54,7.56-7,10.06-3.39,2.44-7.42,3.35-11.53,2.59-3.99-.74-7.37-2.88-9.94-5.96-8.15-9.27-18.22-13.78-30.58-13.78-7.31,0-14.25,1.6-20.46,5.55-6.04,3.84-10.53,9.03-13.72,15.42-3.65,7.3-5.04,15.34-5.04,23.45s1.53,15.89,5.33,23.04c3.47,6.52,8.3,11.68,14.63,15.48,6.65,3.99,14.02,5.64,21.73,5.64,5.22,0,10.46-.64,15.44-2.24,4.33-1.4,8.24-3.57,11.67-6.59l.14-.12c2.93-2.44,6.37-4.06,10.2-4.35,4.08-.31,7.85.99,11.01,3.57l.16.13.15.14c3.1,2.86,5.16,6.46,5.61,10.68.5,4.64-1.21,8.83-4.63,11.97-13.96,12.79-30.97,18.41-49.75,18.41-13.58,0-26.59-3.05-38.32-10.01-11.23-6.67-20.11-15.82-26.52-27.2-6.7-11.89-9.68-24.96-9.68-38.55s2.78-26.7,9.25-38.69c6.09-11.28,14.57-20.49,25.48-27.24,11.35-7.02,24.04-10.08,37.33-10.08,10.68,0,21.08,2.07,30.79,6.59,9.74,4.54,17.96,11.29,24.74,19.59Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: -65.49,
    y: 112.37,
    width: 258.34,
    height: 1.12,
    transform: "translate(-65.96 113.22) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: -64.83,
    y: 112.72,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.95 113.98) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: -64.16,
    y: 113.1,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.93 114.76) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: -63.48,
    y: 113.47,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.92 115.54) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: -62.81,
    y: 113.85,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.91 116.32) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: -62.13,
    y: 114.23,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.89 117.11) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: -61.46,
    y: 114.61,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.88 117.89) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: -60.79,
    y: 114.99,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.86 118.67) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: -60.11,
    y: 115.36,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.85 119.45) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -59.44,
    y: 115.74,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.83 120.23) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -58.76,
    y: 116.12,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.82 121.02) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -58.09,
    y: 116.5,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.8 121.78) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -57.42,
    y: 116.88,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.79 122.57) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: -56.74,
    y: 117.26,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.78 123.35) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: -56.07,
    y: 117.63,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.76 124.14) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: -55.39,
    y: 118.01,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.75 124.92) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: -54.72,
    y: 118.39,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.73 125.7) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: -54.04,
    y: 118.77,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.72 126.48) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -53.37,
    y: 119.15,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.7 127.27) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: -52.7,
    y: 119.52,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.69 128.04) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: -52.02,
    y: 119.9,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.67 128.82) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: -51.35,
    y: 120.28,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.66 129.57) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -50.67,
    y: 120.66,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.64 130.38) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: -50,
    y: 121.04,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.63 131.17) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: -49.33,
    y: 121.42,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.62 131.95) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: -48.65,
    y: 121.79,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.6 132.73) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -47.98,
    y: 122.17,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.59 133.51) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: -47.3,
    y: 122.55,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.57 134.29) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: -46.63,
    y: 122.93,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.56 135.08) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: -45.96,
    y: 123.31,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.54 135.85) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -45.28,
    y: 123.68,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.53 136.63) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: -44.61,
    y: 124.06,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.51 137.41) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -43.93,
    y: 124.44,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.5 138.19) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: -43.26,
    y: 124.82,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.49 138.96) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: -42.59,
    y: 125.2,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.47 139.76) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: -41.91,
    y: 125.57,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.46 140.54) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: -41.24,
    y: 125.95,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.44 141.32) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: -40.56,
    y: 126.33,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.43 142.12) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: -39.89,
    y: 126.71,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.41 142.9) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: -39.21,
    y: 127.09,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.4 143.66) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: -38.54,
    y: 127.47,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.38 144.44) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -37.87,
    y: 127.84,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.37 145.23) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: -37.19,
    y: 128.22,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.36 145.97) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: -36.52,
    y: 128.6,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.34 146.75) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: -35.84,
    y: 128.98,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.33 147.57) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: -35.17,
    y: 129.36,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.31 148.35) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: -34.5,
    y: 129.73,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.3 149.14) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: -33.82,
    y: 130.11,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.28 149.91) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -33.15,
    y: 130.49,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.27 150.69) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -32.47,
    y: 130.87,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.25 151.47) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: -31.8,
    y: 131.25,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.24 152.25) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: -31.13,
    y: 131.63,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.22 153.03) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: -30.45,
    y: 132,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.21 153.82) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: -29.78,
    y: 132.38,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.2 154.6) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -29.1,
    y: 132.76,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.18 155.38) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: -28.43,
    y: 133.14,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.17 156.15) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: -27.76,
    y: 133.52,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.15 156.94) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: -27.08,
    y: 133.89,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.14 157.72) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: -26.41,
    y: 134.27,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.12 158.52) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: -25.73,
    y: 134.65,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.11 159.3) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: -25.06,
    y: 135.03,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.09 160.06) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -24.38,
    y: 135.41,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.08 160.84) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: -23.71,
    y: 135.79,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.07 161.63) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: -23.04,
    y: 136.16,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.05 162.41) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: -22.36,
    y: 136.54,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.04 163.16) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: -21.69,
    y: 136.92,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.02 163.96) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: -21.01,
    y: 137.3,
    width: 258.34,
    height: 1.16,
    transform: "translate(-65.01 164.75) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: -20.34,
    y: 137.68,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.99 165.53) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: -19.67,
    y: 138.05,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.98 166.31) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: -18.99,
    y: 138.43,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.96 167.09) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: -18.32,
    y: 138.81,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.95 167.87) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: -17.64,
    y: 139.19,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.94 168.66) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: -16.97,
    y: 139.57,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.92 169.44) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -16.3,
    y: 139.94,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.9 170.22) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: -15.62,
    y: 140.32,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.89 171) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: -14.95,
    y: 140.7,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.88 171.78) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -14.27,
    y: 141.08,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.86 172.56) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: -13.6,
    y: 141.46,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.85 173.33) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: -12.93,
    y: 141.84,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.83 174.13) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: -12.25,
    y: 142.21,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.82 174.9) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: -11.58,
    y: 142.59,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.8 175.71) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: -10.9,
    y: 142.97,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.79 176.47) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -10.23,
    y: 143.35,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.77 177.25) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: -9.55,
    y: 143.73,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.76 178.03) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: -8.88,
    y: 144.1,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.75 178.79) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: -8.21,
    y: 144.48,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.74 179.55) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: -7.53,
    y: 144.86,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.73 180.33) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: -6.86,
    y: 145.24,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.71 181.14) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -6.18,
    y: 145.62,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.69 181.93) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: -5.51,
    y: 146,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.67 182.71) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: -4.84,
    y: 146.37,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.66 183.5) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: -4.16,
    y: 146.75,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.64 184.28) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: -3.49,
    y: 147.13,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.63 185.06) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: -2.81,
    y: 147.51,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.62 185.84) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: -2.14,
    y: 147.89,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.6 186.6) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: -1.47,
    y: 148.26,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.59 187.4) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: -0.79,
    y: 148.64,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.57 188.19) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: -0.12,
    y: 149.02,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.56 188.96) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 0.56,
    y: 149.4,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.54 189.74) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 1.23,
    y: 149.78,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.53 190.51) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 1.9,
    y: 150.16,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.51 191.31) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 2.58,
    y: 150.53,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.5 192.11) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 3.25,
    y: 150.91,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.48 192.89) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 3.93,
    y: 151.29,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.47 193.65) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 4.6,
    y: 151.67,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.46 194.43) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 5.28,
    y: 152.05,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.44 195.22) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 5.95,
    y: 152.42,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.43 195.98) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 6.62,
    y: 152.8,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.42 196.73) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 7.3,
    y: 153.18,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.4 197.55) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 7.97,
    y: 153.56,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.39 198.33) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 8.65,
    y: 153.94,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.37 199.12) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 9.32,
    y: 154.31,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.36 199.9) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 9.99,
    y: 154.69,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.34 200.68) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 10.67,
    y: 155.07,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.33 201.46) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 11.34,
    y: 155.45,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.31 202.25) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 12.02,
    y: 155.83,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.3 203.02) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 12.69,
    y: 156.21,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.29 203.79) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 13.36,
    y: 156.58,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.27 204.58) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 14.04,
    y: 156.96,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.25 205.36) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 14.71,
    y: 157.34,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.24 206.15) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 15.39,
    y: 157.72,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.23 206.93) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 16.06,
    y: 158.1,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.21 207.69) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 16.73,
    y: 158.47,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.2 208.49) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 17.41,
    y: 158.85,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.17 209.31) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 18.08,
    y: 159.23,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.17 210.05) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 18.76,
    y: 159.61,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.15 210.83) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 19.43,
    y: 159.99,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.14 211.61) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 20.11,
    y: 160.37,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.12 212.4) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 20.78,
    y: 160.74,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.12 213.13) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 21.45,
    y: 161.12,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.09 213.96) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 22.13,
    y: 161.5,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.08 214.74) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 22.8,
    y: 161.88,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.07 215.5) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 23.48,
    y: 162.26,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.05 216.31) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 24.15,
    y: 162.63,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.04 217.08) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 24.82,
    y: 163.01,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.02 217.86) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 25.5,
    y: 163.39,
    width: 258.34,
    height: 1.16,
    transform: "translate(-64.01 218.64) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 26.17,
    y: 163.77,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.99 219.42) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 26.85,
    y: 164.15,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.98 220.21) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 27.52,
    y: 164.52,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.97 220.97) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 28.19,
    y: 164.9,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.95 221.77) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 28.87,
    y: 165.28,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.94 222.55) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 29.54,
    y: 165.66,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.92 223.33) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 30.22,
    y: 166.04,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.91 224.11) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 30.89,
    y: 166.42,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.89 224.89) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 31.56,
    y: 166.79,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.87 225.7) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 32.24,
    y: 167.17,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.86 226.46) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 32.91,
    y: 167.55,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.85 227.23) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 33.59,
    y: 167.93,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.83 228.01) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 34.26,
    y: 168.31,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.82 228.8) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 34.94,
    y: 168.68,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.82 229.53) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 35.61,
    y: 169.06,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.8 230.32) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 36.28,
    y: 169.44,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.78 231.14) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 36.96,
    y: 169.82,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.76 231.92) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 37.63,
    y: 170.2,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.75 232.7) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 38.31,
    y: 170.58,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.73 233.48) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 38.98,
    y: 170.95,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.72 234.27) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 39.65,
    y: 171.33,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.7 235.04) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 40.33,
    y: 171.71,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.69 235.83) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 41,
    y: 172.09,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.67 236.61) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 41.68,
    y: 172.47,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.66 237.39) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 42.35,
    y: 172.84,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.65 238.15) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 43.02,
    y: 173.22,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.63 238.95) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 43.7,
    y: 173.6,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.62 239.73) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 44.37,
    y: 173.98,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.6 240.51) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 45.05,
    y: 174.36,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.58 241.3) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 45.72,
    y: 174.74,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.56 242.1) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 46.39,
    y: 175.11,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.55 242.89) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 47.07,
    y: 175.49,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.54 243.64) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 47.74,
    y: 175.87,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.53 244.43) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 48.42,
    y: 176.25,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.52 245.2) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 49.09,
    y: 176.63,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.5 245.98) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 49.77,
    y: 177,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.5 246.71) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 50.44,
    y: 177.38,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.47 247.54) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 51.11,
    y: 177.76,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.45 248.33) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 51.79,
    y: 178.14,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.44 249.1) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 52.46,
    y: 178.52,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.43 249.88) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 53.14,
    y: 178.89,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.41 250.67) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 53.81,
    y: 179.27,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.4 251.45) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.48,
    y: 179.65,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.38 252.23) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.16,
    y: 180.03,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.37 253.01) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.83,
    y: 180.41,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.36 253.79) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 56.51,
    y: 180.79,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.34 254.57) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 57.18,
    y: 181.16,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.33 255.34) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 57.85,
    y: 181.54,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.31 256.13) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 58.53,
    y: 181.92,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.3 256.91) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 59.2,
    y: 182.3,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.28 257.69) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 59.88,
    y: 182.68,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.27 258.48) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 60.55,
    y: 183.05,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.24 259.29) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 61.22,
    y: 183.43,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.24 260.04) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 61.9,
    y: 183.81,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.23 260.82) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 62.57,
    y: 184.19,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.21 261.6) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 63.25,
    y: 184.57,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.19 262.39) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 63.92,
    y: 184.95,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.2 263.1) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 64.6,
    y: 185.32,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.19 263.89) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 65.27,
    y: 185.7,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.15 264.72) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 65.94,
    y: 186.08,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.14 265.51) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 66.62,
    y: 186.46,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.12 266.29) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 67.29,
    y: 186.84,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.11 267.07) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 67.97,
    y: 187.21,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.1 267.85) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 68.64,
    y: 187.59,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.09 268.61) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 69.31,
    y: 187.97,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.06 269.42) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 69.99,
    y: 188.35,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.05 270.19) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 70.66,
    y: 188.73,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.04 270.97) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 71.34,
    y: 189.11,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.02 271.75) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 72.01,
    y: 189.48,
    width: 258.34,
    height: 1.16,
    transform: "translate(-63.01 272.51) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 72.68,
    y: 189.86,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.99 273.33) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 73.36,
    y: 190.24,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.98 274.1) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 74.03,
    y: 190.62,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.96 274.88) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 74.71,
    y: 191,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.94 275.69) rotate(-60.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 75.38,
    y: 191.37,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.93 276.45) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 76.06,
    y: 191.75,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.92 277.22) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 76.73,
    y: 192.13,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.91 277.98) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 77.4,
    y: 192.51,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.89 278.78) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 78.08,
    y: 192.89,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.88 279.56) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 78.75,
    y: 193.26,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.88 280.3) rotate(-60.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 79.43,
    y: 193.64,
    width: 258.34,
    height: 1.16,
    transform: "translate(-62.85 281.13) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 85.8,
    y: 190.68,
    width: 258.34,
    height: 14.23,
    transform: "translate(-62.71 288.51) rotate(-60.71)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logoLight.e558c215051fb8440dc85a1d5dcb5d04.svg";
export { ForwardRef as ReactComponent };